import { render } from "./Modal.vue?vue&type=template&id=c1f30f9a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=c1f30f9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c1f30f9a"

export default script